import React, { useState, useEffect } from "react";
import CustomBreadCrumb from "../../Other/CustomBreadCrumb";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import CartButton from "./CartButton/CartButton";
import "../CourseDetails/courseDetails.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import RenderRating from "../../Other/StarRating/RenderRating";
import RateCourse from "../../Other/StarRating/RateCourse";
import { buildCourseDetailsURI, handleViewsFormat } from "../../../_helpers";
import { Link } from "react-router-dom";
import Share from "../CourseShare/courseShare";
import { getS3URL } from "../../../_helpers";

const CourseModal = ({ post, setModal }) => {
  const { t } = useTranslation();
  const { loggedIn } = useSelector((state) => state.authentication);
  const [showRateCourseModal, setShowRateCourseModal] = useState(false);
  const [shareShow, setShareShow] = useState(false);
  const [modalClose, setModalClose] = useState(false);

  const handleCloseModal = () => {
    setShowRateCourseModal(false);
  };

  const handleShowModal = () => {
    setShowRateCourseModal(true);
  };

  const handleShare = () => {
    setShareShow(!shareShow);
  };

  return (
    <>
      {!modalClose && (
        <OverlayContainer>
          <div>
            <div className="modal-div">
              <div className="modal-close" onClick={() => setModal(false)}>
                <i className="icon-close" />
              </div>
              <div className="inner-modal-div">
                <div className="modalFlex-wrap">
                  <CustomBreadCrumb />
                  <div className="int-modal-flex-wrapper">
                    <div className="modal-wishlist-wrapper">
                      <span className="icon icon-like"></span>
                    </div>

                    <div
                      className="modalShare-course-wrapper"
                      onClick={handleShare}
                    >
                      <i className="modal-share-icon"></i>
                    </div>
                  </div>
                </div>
                <div className="course-modal-banner-main">
                  <div className="banner-modal-course-left">
                    <div className="course-modal-header">{post.CourseName}</div>
                    <div className="banner-modal-sub">
                      {post.courseOneLiner}
                    </div>
                    <div className="Modal-EnrollmentFee">
                      <div className="course-modal-price-wrapper">
                        {post.isPurchased ? (
                          <div className="purchase-modal-wrapper">
                            {t("Purchased Course")}
                          </div>
                        ) : (
                          <>
                            <div className="course-modal-price">
                              <span>{post && post.EnrollmentFee}</span>
                            </div>
                            <div className="coupon-modal-code">
                              <ul>
                                {/* <li>Got a discount code?</li> */}
                                <li>
                                  Purchase subscription{" "}
                                  <button className="subscription-btn">
                                    New
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="star-modal-rateingmenu">
                        <div className="rating-modal-title">
                          <div className="sub-modal-title">{t("Reviews")}</div>
                          <div className="ratings-modal-wrapper">
                            <RenderRating ratings={Number(post.StarRating)} />

                            {showRateCourseModal && (
                              <RateCourse onClose={handleCloseModal} />
                            )}
                          </div>
                        </div>
                        <div className="sub-modal-title">
                          {loggedIn && (
                            <div
                              className="rate-modal-course-title"
                              onClick={handleShowModal}
                            >
                              {t("Rate this Course?")}
                            </div>
                          )}
                        </div>
                        <div>
                          <p className="sub-modal-title">
                            {t("Course views")} &nbsp;
                            {handleViewsFormat(
                              post?.courseViews === null ? 0 : post.courseViews
                            )}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <img
                        src={
                          post.imageFiles.length > 0
                            ? getS3URL(post.imageFiles[0].fileName)
                            : getS3URL("UI/icons/icon-brokenImg.svg")
                        }
                        alt="course-img"
                        className="perview-image"
                      />
                    </div>

                    <div className="banner-modal-course-right">
                      <div
                        className="flex-modal-right"
                        style={{ margin: "0px" }}
                      >
                        <ul>
                          {!post.isPurchased && (
                            <li
                              className="Basket-modal"
                              style={{ marginLeft: "0px" }}
                            >
                              <CartButton post={post} />
                            </li>
                          )}

                          <li className="Basket-modal">
                            <Link
                              to={{
                                pathname: buildCourseDetailsURI(
                                  post.Category,
                                  post.CourseName,
                                  post.ID
                                ),
                              }}
                            >
                              View More Details
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </OverlayContainer>
      )}
      {shareShow && <Share handleClose={handleShare} />}
    </>
  );
};

export default CourseModal;
